import { Component } from '@angular/core';
import { DeepLinkService } from './shared/deep-link.service';

/**
 * Thin application shell: just hosts the router outlet. The dashboard lives at the
 * '' route (AppComponent) and Claudia is lazy-loaded at '/claudia'. This component
 * is what index.html's <app-root> bootstraps.
 */
@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class RootComponent {
  // Created first, so the URL's deep link is parsed before any tab or chart is built.
  constructor(_link: DeepLinkService) {}
}
